import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { ModalButton } from 'src/components/Global/Button/Button'
import CheckoutPage from 'src/components/HomePage/ModalsContent/Withdrawal/Checkout/CheckoutPage'
import { removeComma } from 'src/utils/addNairaSign'
import {
  BeneficiaryWrapper,
  BankDetails,
  AddBankWrapper,
  CheckOutBtnWrapper,
} from './style'

const BeneficiaryAccount = ({
  userBanks,
  bank,
  setBank,
  amount,
  sourceId,
  fullWithdrawal,
  balance,
}: any) => {
  const disableBtn =
    amount === '' || Number(amount) > Number(removeComma(balance.toString()))
  const location = useLocation()
  const toggleBank = (b: any) => {
    setBank(b)
  }

  const [showCheckoutPage, setShowCheckoutPage] = useState(false)

  const handleCheckoutModal = () => {
    setShowCheckoutPage(true)
  }

  return (
    <>
      <BeneficiaryWrapper>
        <BankDetails>
          {userBanks?.slice(0, 2).map((item: any) => {
            return (
              <div
                className="user_bank"
                key={item}
                onClick={() => toggleBank(item)}
              >
                <div className="img_wrapper">
                  <img src={item.bank_logo} alt="" />
                </div>
                <div className="account_name_number">
                  <p className="account">{item.account_number}</p>
                  <p className="account_name">{item.account_name}</p>
                </div>
              </div>
            )
          })}
        </BankDetails>
        <AddBankWrapper>
          <Link
            to={`/bank-setting`}
            state={{ backgroundLocation: location }}
            className="add_bank_link"
          >
            + &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Add Bank Account
          </Link>
        </AddBankWrapper>
      </BeneficiaryWrapper>
      <CheckOutBtnWrapper>
        <ModalButton onClick={handleCheckoutModal} disabled={disableBtn}>
          Continue
        </ModalButton>
      </CheckOutBtnWrapper>

      <CheckoutPage
        showCheckoutPage={showCheckoutPage}
        setShowCheckoutPage={setShowCheckoutPage}
        bank={bank}
        amount={amount}
        fullWithdrawal={fullWithdrawal}
        sourceId={sourceId}
        balance={balance}
      />
    </>
  )
}

export default BeneficiaryAccount
